enum PENDING_APP_STATUS {
    PENDING = 'P',
    APPROVED = 'A',
    REJECTED = 'R',
    EXPIRED = 'E',
    CANCELLED = 'C',
    UNIDENTIFIED = 'U',
}

enum FeedbackType {
    ACCEPTED,
    REJECTED,
}

export { PENDING_APP_STATUS, FeedbackType };
